import React from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import * as actions from "../../actions/actions";
import IconHero from "../nounproject-icon-hero.jsx";
import { NO_PREMIUM_FEATURES, YES_DO_UPSELL } from "../../reducers/download";

class DownloadFlowModal extends React.Component {
    constructor(props) {
        super(props);
        this.onConfirm = this.onConfirm.bind(this);
        this.onDismiss = this.onDismiss.bind(this);
    }

    onConfirm(evt) {
        if (this.props.onCloseAction) {
            this.props.onCloseAction();
        }
        this.props.dismissModal();
    }

    onDismiss(evt) {
        if (this.props.onCloseAction) {
            this.props.onCloseAction();
        }
        this.props.dismissModal();
    }

    render() {
        let classes = classnames("download-flow-modal");
        return (
            <div className={classes}>
                <IconHero
                    icon={this.props.icon}
                    refech={this.props.refetchIcon}
                    onCloseAction={this.onDismiss}
                />
            </div>
        );
    }
}

export default DownloadFlowModal;
